import { Injectable, NgZone } from '@angular/core';
import { interval } from 'rxjs';
import { switchMap, map, takeWhile } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiInfoClient } from 'src/shared/api';

export interface AppVersion {
	major: number;
	minor: number;
	build: string | number;
	revision?: number;
}

@Injectable({
	providedIn: 'root',
})
export class VersionCheckerService {
	newVersion = true;
	currentAppVersion: AppVersion;

	constructor(
		private snackBar: MatSnackBar,
		private ngZone: NgZone,
		private apiInfoClient: ApiInfoClient
	) {
		this.apiInfoClient.version().subscribe((x) => {
			this.currentAppVersion = this.parseAppVersion(
				x.versionNumberWithBuildNumber
			);
		});
	}

	public startPollingVersion() {
		this.ngZone.runOutsideAngular(() => {
			interval(300000)
				.pipe(
					takeWhile(() => this.newVersion),
					switchMap(() => this.apiInfoClient.version()),
					map((response) =>
						this.parseAppVersion(
							response.versionNumberWithBuildNumber
						)
					)
				)
				.subscribe((appVer: AppVersion) => {
					if (
						!(
							~~this.currentAppVersion.major === ~~appVer.major &&
							~~this.currentAppVersion.minor === ~~appVer.minor &&
							~~this.currentAppVersion.build === ~~appVer.build &&
							~~this.currentAppVersion.revision ===
								~~appVer.revision
						)
					) {
						this.newVersion = false;
						console.info(
							'currentAppVersion',
							this.currentAppVersion
						);
						console.info('appVer', appVer);
						// TODO: Needs action button to refresh
						this.snackBar.open(
							'New Version of RAILS.  Please refresh.'
						);
					}
				});
		});
	}

	getAppVersion(): any {
		return this.apiInfoClient.version();
	}

	parseAppVersion(appVer: string): AppVersion {
		// TODO: Handle possible missing parts, such as revision.
		const v = appVer.split('.');

		return <AppVersion>{
			major: ~~v[0],
			minor: ~~v[1],
			build: ~~v[2],
			revision: ~~v[3],
		};
	}
}
